import { getConfig } from '../../../config/config'

export default class BudgetBlackCampaign {
  static campaignExpirationDate(): string {
    return getConfig().budget_black_campaign.expirationDate
  }
}